import React from "react";
import styled from "@emotion/styled";
import { PanelGroup } from "../PanelGroup";
import { Handle } from "../Handle";
import { TabList } from "../PanelGroup/TabList";
import { TabItem } from "../PanelGroup/TabItem";
import { TabContent } from "../PanelGroup/TabContent";
import { TabPane } from "../PanelGroup/TabPane";
import { ToolboxPanel } from "./ToolboxPanel";

export const LeftPanelStyled = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  position: relative;
  width: 300px;
  min-width: 60px;
  max-width: 25%;
  max-height: 100%;
  padding: 0;
  z-index: 10;
  background-color: var(--builder-panel-background);
`;

export const LeftPanel = () => {
  return (
    <LeftPanelStyled>
      <Handle />
      <PanelGroup activeKey="studio">
        <TabList>
          <TabItem tabKey="studio">Studio</TabItem>
        </TabList>
        <TabContent>
          <TabPane tabKey="studio">
            <ToolboxPanel />
          </TabPane>
        </TabContent>
      </PanelGroup>
    </LeftPanelStyled>
  );
};
